<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs4 sm4 md4>
              <div style="">
                <p class="font-weight-bold">
                  Account ID: {{ accountId }}
                </p>
                <p class="font-weight-bold">
                  Lớp học: {{ className }}
                </p>
                <p class="font-weight-bold">
                  Họ và tên: {{ accountName }}
                </p>
                <p class="font-weight-bold">
                  Phone: {{ phoneNumber }}
                </p>
                <p class="font-weight-bold">
                  Zalo PH: {{ zaloPH }}
                </p>
                <p class="font-weight-bold">
                  Năm sinh: {{ birthYear }}
                </p>
              </div>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <p class="font-weight-bold">
                Unit chuẩn: {{ classCurrentUnit }}
              </p>
              <p class="font-weight-bold">
                Level chuẩn: {{ classCurrentLevel }}
              </p>
              <p class="font-weight-bold">
                Unit hiện tại: {{ unitCurrent }}
              </p>
              <p class="font-weight-bold">
                Level hiện tại: {{ levelCurrent }}
              </p>
              <p class="font-weight-bold">
                Unit lệch: {{ unitDeviate }}
              </p>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <p class="font-weight-bold">
                Số nhiệm vụ đã làm: {{ missionNumber }}
              </p>
              <p class="font-weight-bold">
                Live class: {{ liveclassNumber }}
              </p>
              <p class="font-weight-bold">
                Category: {{ categoryNumber }}
              </p>
              <p class="font-weight-bold">
                Midterm test: {{ middleTest }}
              </p>
              <p class="font-weight-bold">
                Final test: {{ finalTest }}
              </p>
            </v-flex>

            <v-flex>
              <v-btn color="blue" @click="onHistory" :disabled="loading" style="color: white">
                Bài học
              </v-btn>
              <v-btn color="blue" @click="onLiveClass" :disabled="loading" style="color: white">
                Live class
              </v-btn>
              <v-btn color="blue" @click="onCategory" :disabled="loading" style="color: white">
                Category
              </v-btn>
              <br>
              <v-btn color="blue" @click="onMission" :disabled="loading" style="color: white">
                Nhiệm vụ tuần
              </v-btn>
              <v-btn color="blue" @click="onFeedback" :disabled="loading" style="color: white">
                Feedback PH
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>

            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="grey" @click="onCancel" :disabled="loading">
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
  name: "ImportRequestView",
  components: {CTextboxFloat, IDatepicker},
  data: () => {
    return {
      formName: "Thông tin chi tiết học sinh",
      loading: false,
      warehouseCode: "",
      roleGroup: 0,
      userId: '',
      isEdit: false,
      accountId: null,
      phoneNumber: null,
      accountName: null,
      birthYear: null,
      zaloPH: null,
      classId: null,
      unitCurrent: null,
      className: null,
      classCurrentUnit: null,
      unitDeviate: null,
      missionNumber: null,
      levelCurrent:null,
      liveclassNumber: null,
      classCurrentLevel: null,
      categoryNumber: null,
      middleTest: null,
      finalTest: null,
      deleteDialog: false,
      requestOrder: null,
      importRequest: {
        status: 1,
        dateArrived: '',
      },
      historyDlg: false,
      lstHistory: [],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/babiAccountClass/detail/" + this.$route.params.id, {
          accountId: this.$route.params.id,
          status: 1
        }
    )
        .then(
            (data) => {
              if (data.items.length > 0) {
                for (let i = 0; i < data.items.length; i++) {
                  if (data.items[i].accountId == this.$route.params.id) {
                    this.accountId = data.items[i].accountId;
                    this.classId = data.items[i].classId;
                    this.birthYear = data.items[i].birthYear;
                    this.className = data.items[i].className;
                    this.accountName = data.items[i].accountName;
                    this.phoneNumber = data.items[i].phoneNumber;
                    this.zaloPH = data.items[i].zaloPH;
                    this.unitCurrent = data.items[i].unitCurrent;
                    this.classCurrentUnit = data.items[i].classCurrentUnit;
                    this.unitDeviate= data.items[i].unitDeviate;
                    this.missionNumber = data.items[i].missionNumber;
                    this.liveclassNumber = data.items[i].liveclassNumber;
                    this.categoryNumber = data.items[i].categoryNumber;
                    this.middleTest = data.items[i].middleTest;
                    this.finalTest = data.items[i].finalTest;
                    this.classCurrentLevel = data.items[i].classCurrentLevel;
                    this.levelCurrent = data.items[i].levelCurrent;
                  }
                }
              }
            }
        );
  },

  computed: {},

  methods: {
    onCancel() {
      //this.$router.push({ path: '/importRequest' });
      this.$router.push({path: '/babiAccountClass/view/' + this.classId, query: this.$route.query});
    },

    onLiveClass() {
      this.$router.push({path: '/babiLiveClassPointInfo/view/' + this.accountId, query: this.$route.query});
    },

    onCategory() {
      this.$router.push({path: '/babiCategoryPointInfo/view/' + this.accountId, query: this.$route.query});
    },

    onMission() {
      this.$router.push({path: '/babiMissions/view/' + this.accountId, query: this.$route.query});
    },

    onFeedback() {
      this.$router.push({path: '/babiFeedback/view/' + this.accountId, query: this.$route.query});
    },

    onHistory() {
      this.$router.push({path: '/babiPartPointInfo/view/' + this.accountId, query: this.$route.query});
    },
  },

  destroyed() {
  },
};
</script>
